/** Fallback city list when TaskApi getCity fails. Keys = state names from API. */
export const stateCityMapping = {
  Delhi: ['New Delhi', 'Central Delhi', 'South Delhi', 'East Delhi', 'West Delhi', 'North Delhi'],
  Haryana: ['Gurgaon', 'Faridabad', 'Panipat', 'Ambala', 'Hisar', 'Karnal', 'Rohtak'],
  'Uttar Pradesh': ['Noida', 'Ghaziabad', 'Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Meerut'],
  Maharashtra: ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad'],
  Karnataka: ['Bengaluru', 'Mysuru', 'Mangaluru', 'Hubballi', 'Belagavi'],
  Gujarat: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar'],
  Rajasthan: ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer'],
  Punjab: ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala'],
  'Madhya Pradesh': ['Bhopal', 'Indore', 'Gwalior', 'Jabalpur'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli'],
  Telangana: ['Hyderabad', 'Warangal', 'Nizamabad'],
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Tirupati'],
  Kerala: ['Kochi', 'Thiruvananthapuram', 'Kozhikode'],
  'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Siliguri'],
  Uttarakhand: ['Dehradun', 'Haridwar', 'Nainital'],
  Chandigarh: ['Chandigarh'],
};

export function getFallbackCities(stateName) {
  if (!stateName) return [];
  const exact = stateCityMapping[stateName];
  if (exact) return exact.map((city, idx) => ({ city_id: `local-${idx}`, city }));
  const key = Object.keys(stateCityMapping).find(
    (k) => k.toLowerCase() === String(stateName).toLowerCase()
  );
  if (!key) return [];
  return stateCityMapping[key].map((city, idx) => ({
    city_id: `local-${idx}`,
    city,
  }));
}
